import { render, staticRenderFns } from "./WaterSourceMonitoring.vue?vue&type=template&id=72d1c27a&scoped=true"
import script from "./WaterSourceMonitoring.vue?vue&type=script&lang=js"
export * from "./WaterSourceMonitoring.vue?vue&type=script&lang=js"
import style0 from "./WaterSourceMonitoring.vue?vue&type=style&index=0&id=72d1c27a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1c27a",
  null
  
)

export default component.exports